// extracted by mini-css-extract-plugin
export default {"login-link":"reset-password_login-link__LjHlc","reset_password_input":"reset-password_reset_password_input__yThzx"};